export const INVENTORY_ITEM_CATEGORY_ID_TYPES = {
  /**
   * 가장 기본적인 가상화페인 GEM을 나타내는 카테고리 ID.
   */
  GEMS: 'GEMS',
  /**
   * Category of Gem Subscriptions, with  "periodic reward grants".
   *
   * Items of this category can request for "periodic reward grants" through,
   * {@link GooglePlayIabService#requestGooglePlayPeriodicRewardGrant(String)}.
   */
  GEM_SUB_PR: 'GEM_SUB_PR',
  /**
   * Category of VIP Subscription
   *
   */
  VIP: 'VIP',
  /**
   * Category of Lounge Plus Subscription
   */
  LOUNGE_PLUS: 'LOUNGE_PLUS',
  /**
   * Category of Lounge Boost
   *
   */
  LOUNGE_BOOST: 'LOUNGE_BOOST',
  /**
   * 지역선택 아이템 카테고리 ID.
   */
  REGION_CHOICE: 'REGION_CHOICE',
  /**
   * Category Id for nickname change item.
   */
  NICKNAME_CHANGE: 'NICKNAME_CHANGE',
  /**
   * Category Id for nickname change vip item.
   */
  V_NICKNAME_CHANGE: 'V_NICKNAME_CHANGE',
  /**
   * 스티커 등의 이펙트 카테고리 ID.
   */
  EFFECT: 'EFFECT',
  /**
   * 액티콘 카테고리 ID.
   */
  ACTICON: 'ACTICON',
  /**
   * Category ID for SKIN
   */
  SKIN: 'SKIN',
  /**
   * Category Id for new effect graphic.
   */
  HF_EFFECT: 'HF_EFFECT',
  /**
   * Category Id for new acticon graphic.
   */
  HF_ACTICON: 'HF_ACTICON',
  /**
   * Category id for new skin graphic.
   */
  HF_SKIN: 'HF_SKIN',
  /**
   * Category id for new makeup.
   */
  HF_MAKEUP: 'HF_MAKEUP',
  /**
   * Category representing the Video Filters. This category isn't included in the user's inventory
   * and is specified just for documentation.
   */
  FILTER: 'FILTER',
  /**
   * Category id for virtual location change.
   */
  VIRTUAL_LOCATION: 'VIRTUAL_LOCATION',
  /**
   * Category id for request add friend.
   *
   * @since 1370
   */
  FRIEND_ADD_REQUEST: 'FRIEND_ADD_REQUEST',
  /**
   * Category id for video call to friend.
   *
   * @since 1370
   */
  VIDEO_CALL: 'VIDEO_CALL',
  /**
   * Category id for use rear camera.
   *
   * @since 1370
   */
  REAR_CAMERA: 'REAR_CAMERA',
  /**
   * Category id for send cool point x100.
   *
   * @since 1370
   */
  THUMBS_UP_100X: 'THUMBS_UP_100X',
  /**
   * Category id for send cool point x30.
   *
   * @since 1370
   */
  THUMBS_UP_30X: 'THUMBS_UP_30X',
  /**
   * Category id for unlimited gender filter item.
   */
  GENDER_FILTER_PERIOD: 'GENDER_FILTER_PERIOD',
  /**
   * Category id for limited gender filter item.
   */
  GENDER_FILTER_COUNT: 'GENDER_FILTER_COUNT',
  /**
   * Category id for limited local guarantee item.
   */
  LOCAL_GUARANTEE_COUNT: 'LOCAL_GUARANTEE_COUNT',
  /**
   * Category id for limited country guarantee filter item.
   * 모든 국가(자국가 + 해외국가)에 대한 확정 매치가 가능한 횟수권 아이템입니다.
   */
  COUNTRY_GUARANTEE_FILTER_COUNT: 'COUNTRY_GUARANTEE_FILTER_COUNT',
  /**
   * Category id for start unlimited gender filter item.
   */
  INACT_GENDER_PERIOD: 'INACT_GENDER_PERIOD',
  /**
   * Category id for limited super match filter item.
   *
   * @since 2300
   */
  SUPER_MATCH_FILTER_COUNT: 'SUPER_MATCH_FILTER_COUNT',
  /**
   * Category id for limited azar pick filter item.
   *
   * @since 2360
   */
  AZAR_PICK_FILTER_COUNT: 'AZAR_PICK_FILTER_COUNT',
  /**
   * Category id for Azar Gem Plus.
   * 명칭 확정 전 Gem Membership으로 구현되었고, 이미 Web Platform에서 해당 명칭을 사용중.
   */
  GEM_MEMBERSHIP: 'GEM_MEMBERSHIP',
  /**
   * Swag 아이템들 중 티어 1 을 묶은 카테고리.
   *
   * @since 1290
   */
  SWAG_TIER_1: 'SWAG_TIER_1',
  SWAG_TIER_: 'SWAG_TIER_',
  /**
   * 액션 포인트를 나타내는 카테고리 Id;
   *
   * @since 1310
   */
  ACTION_POINTS: 'ACTION_POINTS',
  /**
   * Async 피쳐의 Really Interest 기능을 사용하기 위한 아이템의 카테고리 ID.
   *
   * @since 1330
   */
  REALLY_INTEREST: 'REALLY_INTEREST',
  /**
   * Async 피쳐의 Premium 구독 상품에 대한 카테고리 ID.
   *
   * @since 1330
   */
  ASYNC_PREMIUM: 'ASYNC_PREMIUM',
  /**
   * Category id for Azar Pass.
   */
  AZAR_PASS: 'AZAR_PASS',
  /**
   * Category id for Daily Gem.
   */
  DAILY_GEM: 'DAILY_GEM',
  /**
   * Category id for Daily Gem Plus.
   */
  DAILY_GEM_PLUS: 'DAILY_GEM_PLUS',
  /**
   * Source for Google Play Subscription.
   */
  GOOGLE_PLAY_SUBSCRIPTION: 'GOOGLE_PLAY_SUBSCRIPTION',
  /**
   * Source for App Store Subscription.
   */
  APP_STORE_SUBSCRIPTION: 'APP_STORE_SUBSCRIPTION',
  /**
   * Async 피쳐의 친구 신청(Message Product) 상품에 대한 카테고리 ID.
   *
   * @since 1410
   */
  ASYNC_FRIEND_REQUEST: 'ASYNC_FRIEND_REQUEST',
  /**
   * Category id for Gem Plus Lite.
   *
   * @since 1550
   */
  GEM_PLUS_LITE: 'GEM_PLUS_LITE',
  /**
   * Category id for periodic match friend request item.
   * @since 1910
   */
  MATCH_FRIEND_REQUEST_PERIOD: 'MATCH_FRIEND_REQUEST_PERIOD',
  /**
   * Category id for infinite random match item.
   * @Since __NEXT__
   */
  FREE_MATCH_COUNT: 'FREE_MATCH_COUNT',
  /**
   * Category id for Azar Plus.
   * @since 2330
   */
  AZAR_PLUS: 'AZAR_PLUS',
  /**
   * Category id for Azar Premium.
   * @since 2330
   */
  AZAR_PREMIUM: 'AZAR_PREMIUM',
  /**
   * Category id for Azar Supreme.
   * @since 2390
   */
  AZAR_SUPREME: 'AZAR_SUPREME',
  /**
   * Category id for Remove Ad.
   * @since 2540
   */
  REMOVE_AD: 'REMOVE_AD',
  /**
   * Category id for Azar Basic.
   * @since 2540
   */
  AZAR_BASIC: 'AZAR_BASIC',
  /**
   * Category id for Cheero Basic.
   */
  CHEERO_BASIC: 'CHEERO_BASIC',
  /**
   * Category id for Cheero Plus.
   */
  CHEERO_PLUS: 'CHEERO_PLUS',
  /**
   * Category id for Cheero Premium.
   */
  CHEERO_PREMIUM: 'CHEERO_PREMIUM',
  /**
   * Category id for Cheero Supreme.
   */
  CHEERO_SUPREME: 'CHEERO_SUPREME',
  /**
   * Category id for Vividi Plus Subscription.
   */
  VIVIDI_PLUS: 'VIVIDI_PLUS',
  /**
   * Category id for Vividi Unlimited Subscription.
   */
  VIVIDI_UNLIMITED: 'VIVIDI_UNLIMITED',
  /**
   * @see https://hpcnt.slack.com/archives/C02SQS5AJDR/p1771580496545759?thread_ts=1771565745.668989&cid=C02SQS5AJDR.
   */
  PICK_MATCH_DISCOUNT: 'PICK_MATCH_DISCOUNT',
  /**
   * Category id for Azar Core Subscription.
   */
  AZAR_CORE: 'AZAR_CORE',
  /**
   * Category id for Azar Max Subscription.
   */
  AZAR_MAX: 'AZAR_MAX',

  /**
   * Category id for age choice range filter period.
   */
  AGE_CHOICE_RANGE_FILTER_PERIOD: 'AGE_CHOICE_RANGE_FILTER_PERIOD',
} as const;

export type InventoryItemCategoryId =
  (typeof INVENTORY_ITEM_CATEGORY_ID_TYPES)[keyof typeof INVENTORY_ITEM_CATEGORY_ID_TYPES];

/** 구독 관련 상품 카테고리 */
export const SUBSCRIPTION_CATEGORY_IDS = [
  'AZAR_PLUS',
  'AZAR_PREMIUM',
  'AZAR_SUPREME',
  'AZAR_BASIC',
  'AZAR_CORE',
  'AZAR_MAX',
  'CHEERO_BASIC',
  'CHEERO_PLUS',
  'CHEERO_PREMIUM',
  'CHEERO_SUPREME',
  'VIVIDI_PLUS',
  'VIVIDI_UNLIMITED',
] satisfies InventoryItemCategoryId[];

export const ItemSourceName = {
  AZAR_PASS: 'Azar Pass',
  XO_PLUS: 'Lounge',
  FREE_GIFT: 'Free Gift',
  VIP: 'VIP',
};

export type ItemSource = keyof typeof ItemSourceName;

export interface ItemGuideInfo {
  imageUrl: string;
  title: string;
  description: string;
  buttonText: string;
}

interface InventoryItemBase {
  itemId: string;
  categoryId: InventoryItemCategoryId;
  quantity?: number; // quantity가 있는 경우 detailJson 내 groupedItems는 CONSUMALBE이 보장
  dateValidFrom?: number;
  dateValidUntil?: number;
  remainingTimeSeconds?: number; // deprecated
  itemSource?: string; // deprecated
  timeToNextPeriodicRewardGrantSeconds?: number; // deprecated
  savedConsumptionMins?: number; // deprecated
  autoRenewing?: boolean; // subscription이어도 단품결제인 경우 nullable
  displayItem?: boolean;
  groupedItems?: ItemDetail[];
}

export interface InventoryItemDetailJson {
  groupedItems?: ItemDetail[];
  guide?: ItemGuideInfo;
}

/**
 * 클라이언트에서 실질적으로 처리하는 인벤토리 아이템 정보
 */
export interface InventoryItem extends InventoryItemBase {
  detailJson: InventoryItemDetailJson;
}

/**
 * 서버에서 내려주는 인벤토리 아이템 정보 (전송을 위해 일부 필드를 직렬화)
 */
export interface RawInventoryItem extends InventoryItemBase {
  detailJson: string;
}

export interface ItemDetail {
  itemId: string;
  useCount: number;
  dateValidUntil: number;
  displayName: string;
  displayItem: boolean;
  thumbnailImageUrl: string;
  deeplink?: string;
  inventoryId: number;
  itemType: ItemType;
  useButtonText?: string;
  itemSource: string;
  guide?: ItemGuideInfo;
  categoryId?: InventoryItemCategoryId;
}
export enum ItemType {
  CONSUMABLE = 'CONSUMABLE',
  PERIODIC = 'PERIODIC',
  SUBSCRIPTION = 'SUBSCRIPTION',
}
